import React from 'react';
import { useDispatch } from 'react-redux';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import styles from './migrate-first-step-details.module.scss';
import { useGetTheme } from '../../../../../../../hooks/useGetTheme';
import Header from '../../../../../../../components/Stake/header';
import OmIcon from '../../../../../../../assets/images/tokens/om.svg';
import * as omStakeActions from '../../../../../../../actions/om-stake-actions';

const MigrateFirstStepDetails = () => {
  const colors = useGetTheme();
  const dispatch = useDispatch();

  return (
    <>
      <Header
        icon={OmIcon}
        title='OM-Migration'
        onClickBack={() => dispatch(omStakeActions.stakeReset())}
      />
      <CardContent
        style={{
          padding: '0',
          display: 'flex',
          position: 'relative',
          zIndex: 1,
          flexGrow: 1,
        }}
      >
        <div className={styles.container} style={{ color: colors.text }}>
          <div className={styles.description}>
            <span>IMPORTANT!</span> You are about to initiate the migration process into staking
            pool V2 and token swap to OM V2. This will be a two stage process and will entail the
            following steps:
            <br />
            <br />
            <b>Stage 1: Initiate migration</b>
            <br />
            This stage entails staking any unclaimed rewards into staking pool V2, as well as
            initiaiting the exit process of staked V1 OM tokens from staking pool V1. You will need
            to sign two transactions for this stage, after which a timer will kick-off indicating
            the time left until V1 OM tokens are available for migration from staking pool V1 into
            staking pool V2.
            <br />
            <br />
            <b>Stage 2: Claim rewards and complete migration</b>
            <br />
            This stage will become accesible once the 8 day timer has elapsed. During this stage,
            you will (1) claim and stake rewards earned during the 8 day unstaking period; (2)
            withdraw V1 OM tokens from pool V1; (3) approve the sending of V1 OM tokens to the
            migration contract; and finally (4) complete migration and token swap into staked V2 OM
            tokens in the staking pool V2. Once the migration has been completed, you will receive
            sOM (staked OM) in accordance to your resulting V2 OM token staked balance on staking
            pool V2 (please note sOM is not a one-to-one conversion with your staked OM and your sOM
            will be some multiples larger than your staked amount).
          </div>

          <div className={styles.footer} style={{ backgroundColor: colors.cardBackgroundTint }}>
            <Button
              className={styles.button}
              onClick={() => dispatch(omStakeActions.migrateFirstStepSend())}
              variant='contained'
              color='secondary'
            >
              Next
            </Button>
          </div>
        </div>
      </CardContent>
    </>
  );
};

export default MigrateFirstStepDetails;
